(() => {
  const INTERVAL_MS = 5000;

  function fullBleed(el) {
    if (!el) return;
    el.style.width = "100vw";
    el.style.maxWidth = "100vw";
    el.style.marginLeft = "calc(50% - 50vw)";
    el.style.marginRight = "calc(50% - 50vw)";
  }

  function setThumbSizing(container) {
    if (!container) return;

    const items = container.querySelectorAll("li, button, a, .thumbnail, .thumbnail-list__item, [role='tab']");
    items.forEach((item) => {
      item.style.width = "52px";
      item.style.height = "52px";
      item.style.flex = "0 0 52px";
      item.style.maxWidth = "52px";
    });

    const imgs = container.querySelectorAll("img");
    imgs.forEach((img) => {
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "cover";
      img.style.display = "block";
    });

    if (items.length) items[0].style.display = "none";
  }

  function findMainGallery() {
    return (
      document.querySelector("media-gallery") ||
      document.querySelector(".media-gallery") ||
      document.querySelector(".product__media-gallery") ||
      document.querySelector(".product__gallery") ||
      document.querySelector(".product__media-wrapper") ||
      document.querySelector("[data-media-gallery]") ||
      document.querySelector("[data-product-media]")
    );
  }

  function applyFullWidth() {
    const gallery = findMainGallery();
    if (!gallery) return;

    fullBleed(gallery);

    // Also try to full bleed the nearest section wrapper
    const section = gallery.closest("section, .shopify-section, .container, .page-width, .wrapper, .content");
    if (section) {
      section.style.maxWidth = "none";
      section.style.paddingLeft = "0";
      section.style.paddingRight = "0";
    }

    // Force the main media to fill
    const mainMedia = gallery.querySelector("img, video, iframe");
    if (mainMedia && mainMedia.tagName === "IMG") {
      mainMedia.style.width = "100%";
      mainMedia.style.height = "auto";
      mainMedia.style.display = "block";
    }
  }

  function hideFirstThumbAndResize() {
    const gallery = findMainGallery() || document;

    const thumbContainer =
      gallery.querySelector(".thumbnail-list") ||
      gallery.querySelector(".product__thumbnails") ||
      gallery.querySelector(".product-thumbnails") ||
      gallery.querySelector('[role="tablist"]') ||
      document.querySelector(".thumbnail-list") ||
      document.querySelector(".product__thumbnails") ||
      document.querySelector(".product-thumbnails") ||
      document.querySelector('[role="tablist"]');

    setThumbSizing(thumbContainer);
  }

  function setupAutoplay() {
    const gallery = findMainGallery();
    if (!gallery || gallery.dataset.autoInit === "1") return;
    gallery.dataset.autoInit = "1";

    const nextBtn =
      gallery.querySelector('button[name="next"]') ||
      gallery.querySelector(".slider-button--next") ||
      gallery.querySelector('button[aria-label*="Next"]') ||
      document.querySelector('button[name="next"]') ||
      document.querySelector(".slider-button--next") ||
      document.querySelector('button[aria-label*="Next"]');

    let timer = null;

    const start = () => {
      stop();
      timer = window.setInterval(() => {
        if (nextBtn && !nextBtn.disabled) nextBtn.click();
      }, INTERVAL_MS);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    start();

    gallery.addEventListener("pointerenter", stop);
    gallery.addEventListener("pointerleave", start);
    gallery.addEventListener("focusin", stop);
    gallery.addEventListener("focusout", start);
  }

  function init() {
    applyFullWidth();
    hideFirstThumbAndResize();
    setupAutoplay();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();